import { Button, ButtonBase } from '@mui/material';
import React, {
  useContext,
  useDebugValue,
  useEffect,
  useState,
} from 'react';
import {
  useAuth,
} from 'react-oidc-context';
import SetupPayment from './SetupPayment';

import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

import PaymentOutlinedIcon from '@mui/icons-material/PaymentOutlined';

import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';

import SpeciaLogo from '../../resources/speciaLogo.png';
import Subscribe from './Subscribe';
import CancelSubscription from './CancelSubscription';
import { SnackbarContext } from '../../App';

const plans = [
  {
    plan_id: 'payg',
    plan_name: 'Pay-as-you-go',
    description: 'Pay only for what you use. The final amount is calculated based on the number of clients you have each month',
  },
  {
    plan_id: 'fixed',
    plan_name: 'Fixed-price Model',
    description: 'The price is fixed for each month regardless of the numbe rof clients added',
  },
];

const paygPlans = [
  {
    price: 7,
    percentage: 0,
    minNoClients: 0,
    description: 'Start at $7 per client per month with no minimum commitment. As your client base grows, you’ll unlock lower pricing—scale up and save!',
  },
  {
    price: 6,
    percentage: 10,
    minNoClients: 100,
    description: 'Once you exceed 100 clients, your rate drops to $6 per client per month. Keep growing to 200 clients and reduce your cost even further!',
  },
  {
    price: 5,
    percentage: 25,
    minNoClients: 200,
    description: 'Surpass 200 clients and lower your cost to $5 per client per month. Scale up to 500 clients for even greater discounts!',
  },

  {
    price: 4,
    percentage: 45,
    minNoClients: 500,
    description: 'Reach 500 clients and enjoy a lower rate of $4 per client per month. Push past 1,000 clients to unlock even more savings!',
  },
  {
    price: 3,
    percentage: 65,
    minNoClients: 1000,
    description: 'Exceed 1,000 clients and benefit from a reduced rate of $3 per client per month. Keep scaling to 2,000 clients and pay even less!',
  },
  {
    price: 2,
    percentage: 85,
    minNoClients: 2000,
    description: 'Once you surpass 2,000 clients, you get the lowest rate of just $2 per client per month. The bigger your business, the more you save!',
  },
];

function Payment() {
  const [
    paymentMethods,
    setPaymentMethods,
  ] = useState([]);

  const auth = useAuth();

  const [
    paymentSetupShow,
    setPaymentSetupShow,
  ] = useState(false);

  const [
    subscribeShow,
    setSubscribeShow,
  ] = useState(false);

  const [
    defaultPaymentMethod,
    setDefaultPaymentMethod,
  ] = useState();

  const [
    currentNoClients,
    setCurrentNoClients,
  ] = useState();

  const [
    currentPaygRange,
    setCurrentPaygRange,
  ] = useState(1);

  const [
    finalCurrentPlan,
    setFinalCurrentPlan,
  ] = useState();

  const [
    selectedFixedPlan,
    setSelectedFixedPlan,
  ] = useState('gayatri_plan1');

  const [
    estimatedCost,
    setEstimatedCost,
  ] = useState(0);

  const [
    availablePlans,
    setAvailablePlans,
  ] = useState([]);

  const [
    currentPlan,
    setCurrentPlan,
  ] = useState([]);

  const [
    cancelSubscriptionShow,
    setCancelSubscriptionShow,
  ] = useState(false);

  const { snackBarShow, setSnackBarShow, snackBarMessage, setSnackBarMessage, sessionExpired, setSessionExpired } = useContext(SnackbarContext);

  function paymentSetupCloseHandler() {
    setPaymentSetupShow(false);
  }

  function subscribeCloseHandler() {
    setSubscribeShow(false);
  }

  // ✅ Fetch clientSecret when user clicks "Subscribe"
  const fetchAvailablePaymentMethods = async () => {
    fetch(`${window.origin}/api/stripe/payment-method`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth.user?.access_token}`,
      },
    }).then((response) => {
      if (response.status === 403) {
        setSessionExpired(true);
        throw new Error('Session expired');
      }
      // setSnackBarMessage('Invitation sent')
      // setSnackBarShow(true)
      return response.json();
    }).then((data) => {
      setPaymentMethods(data);

      setDefaultPaymentMethod(data.find(item => item.isDefault));
    }).catch((error) => {
      console.error('Failed to fetch payment methods:', error);
      // setSnackBarMessage('Failed to send invitation. Please try again later')
      // setSnackBarShow(true)
    });
  };

  const fetchCurrentPlan = () => {
    fetch(`${window.origin}/api/stripe/plan/current`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth.user?.access_token}`,
      },
    }).then((response) => {
      if (response.status === 403) {
        setSessionExpired(true);
        throw new Error('Session expired');
      }
      return response.json();
    }).then((data) => {
      setCurrentPlan(data);
    }).catch((error) => {
      console.error(error);
    });
  };

  const fetchAvailablePlans = () => {
    fetch(`${window.origin}/api/stripe/plan`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth.user?.access_token}`,
      },
    }).then((response) => {
      if (response.status === 403) {
        setSessionExpired(true);
        throw new Error('Session expired');
      }
      return response.json();
    }).then((data) => {
      setAvailablePlans(data);
    }).catch((error) => {
      console.error(error);
    });
  };

  const fetchNoClients = () => {
    fetch(`${window.origin}/api/client/count`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth.user?.access_token}`,
      },
    }).then((response) => {
      if (response.status === 403) {
        setSessionExpired(true);
        throw new Error('Session expired');
      }
      return response.json();
    }).then((data) => {

    }).catch((error) => {
      console.error(error);
    });
  };

  async function reload() {
    fetchCurrentPlan();
    fetchNoClients();
    fetchAvailablePlans();
  }

  useEffect(() => {
    reload();
  }, []);

  useEffect(() => {
    if (currentPlan.length > 0 && availablePlans) {
      const currentPlanTemp = currentPlan[0];
      console.log(currentPlanTemp);
      if (currentPlan[0]?.stripe_price_id == availablePlans?.flatRate?.stripe_price?.id) {
        setFinalCurrentPlan({ planType: 'Fixed Price', ...currentPlanTemp, ...availablePlans?.flatRate?.stripe_price });
      }

      if (currentPlan[0]?.stripe_price_id == availablePlans?.payg?.stripe_price?.id) {
        setFinalCurrentPlan({ planType: 'Pay-as-you-go', ...currentPlanTemp, ...availablePlans?.payg?.stripe_price });
      }
    }
  }, [
    currentPlan,
    availablePlans,
  ]);

  useEffect(() => {
    fetchAvailablePaymentMethods();
  }, []);

  return (
    <div style={{ padding: '0 2.5vw', paddingBottom: '2.5vw' }}>
      <p style={{ fontSize: '0.8vw', color: 'rgb(0, 15, 30, 0.6)', fontWeight: '300', textAlign: 'center', marginBottom: '2vw' }}>
        Manage your payment method
      </p>

      {/* <div>
                <p style={{color: 'rgb(0, 15, 30, 0.6)', fontSize: '0.8vw', paddingLeft: '0.5vw', margin: 0, marginBottom: '0.8vw'}}>Subscription</p>
                <div style={{color: 'rgb(0, 15, 30, 0.6)', fontSize: '0.9vw', marginTop: '1vw', backgroundColor: 'rgb(254, 254, 255, 0.6)', borderRadius: '1vw', overflow: 'hidden'}}>
                    <div style={{display: 'flex', flexDirection: 'row', padding: '1vw 1.5vw'}}>
                        <div style={{flex: 1, fontSize: '0.75vw', fontWeight: '500'}}>
                            {finalCurrentPlan?.planType == 'Fixed Price' && <p style={{fontSize: '1.5vw', fontWeight: '500', marginBottom: '0.8vw'}}>Instalment Plan</p>}
                            {finalCurrentPlan?.planType == 'Pay-as-you-go' && <p style={{fontSize: '1.5vw', fontWeight: '500', marginBottom: '0.8vw'}}>Pay-as-you-go Plan</p>}
                            {!finalCurrentPlan && <p style={{fontSize: '1.5vw', fontWeight: '500', marginBottom: '0.8vw'}}>Free Trial</p>}
                            {finalCurrentPlan?.planType == 'Fixed Price' && <p style={{marginBottom: '0.5vw', fontWeight: 400 }}><PaymentOutlinedIcon style={{fontSize: '1.2vw', marginRight: '0.5vw', marginBottom: '0.1vw'}}/><span>$3,000 per month</span></p>}
                            {finalCurrentPlan?.planType == 'Pay-as-you-go' && <p style={{marginBottom: '0.5vw', fontWeight: 400 }}><PaymentOutlinedIcon style={{fontSize: '1.2vw', marginRight: '0.5vw', marginBottom: '0.1vw'}}/><span>$2/client per month</span></p>}
                            {!finalCurrentPlan && <p style={{marginBottom: '0.5vw', fontWeight: 400 }}><PaymentOutlinedIcon style={{fontSize: '1.2vw', marginRight: '0.5vw', marginBottom: '0.1vw'}}/><span>$0 per month</span></p>}

                            <p style={{marginBottom: '0vw', fontWeight: 400}}><CalendarMonthOutlinedIcon  style={{fontSize: '1.2vw', marginRight: '0.5vw', marginBottom: '0.1vw'}}/><span>Next payment on {finalCurrentPlan?.next_payment_at? new Intl.DateTimeFormat("en-GB").format(new Date(finalCurrentPlan?.next_payment_at)): "NA"}</span></p>
                        </div>
                        <div>Active</div>
                    </div>
                    <ButtonBase onClick={() => {

                        if(!defaultPaymentMethod){
                          setSnackBarMessage('Please add a payment method before continue')
                          setSnackBarShow(true)
                          return
                        }

                        setSubscribeShow(true)
                      }} style={{width: '100%', display: 'flex', flexDirection: 'row', padding: '1vw 1.5vw', borderTop: '1px solid rgb(0, 15, 30, 0.05)'}}>
                        <div style={{flex: 1, fontWeight: '600', textAlign: 'left'}}>
                            <p style={{margin: 0}}>{ finalCurrentPlan? 'Switch Plan': 'Upgrade Plan'}</p>
                        </div>
                        <div style={{flex: 1, textAlign: 'right'}}>
                            <ArrowForwardIosIcon style={{fontSize: '1vw'}}/>
                        </div>
                    </ButtonBase>
                    {finalCurrentPlan && <ButtonBase onClick={()=> {setCancelSubscriptionShow(true)}} style={{color: 'red',width: '100%', display: 'flex', flexDirection: 'row', padding: '1vw 1.5vw', borderTop: '1px solid rgb(0, 15, 30, 0.05)'}}>
                        <div style={{flex: 1, fontWeight: '600', textAlign: 'left'}}>
                            <p style={{margin: 0}}>Cancel Subscription</p>
                        </div>
                        <div style={{flex: 1, textAlign: 'right'}}>
                            <ArrowForwardIosIcon style={{fontSize: '1vw'}}/>
                        </div>
                    </ButtonBase>}

                </div>
            </div> */}

      <div style={{ marginTop: '2vw' }}>
        <p style={{ color: 'rgb(0, 15, 30, 0.6)', fontSize: '0.8vw', paddingLeft: '0.5vw', margin: 0, marginBottom: '0.8vw' }}>Payment</p>

        <div style={{ color: 'rgb(0, 15, 30, 0.6)', fontSize: '0.9vw', marginTop: '1vw', backgroundColor: 'rgb(254, 254, 255, 0.6)', borderRadius: '1vw', overflow: 'hidden' }}>
          {defaultPaymentMethod && (
            <>
              <div style={{ width: '100%', display: 'flex', flexDirection: 'row', color: 'rgb(0, 15, 30, 0.6)', fontSize: '0.9vw', marginTop: '0vw', paddingRight: '1.5vw', borderBottom: '1px solid rgb(0, 15, 30, 0.05)' }}>
                <div>
                  <div style={{ padding: '1vw 2.5vw', fontSize: '1.2vw', fontWeight: '500', color: 'rgb(255, 255, 255, 0.9)', margin: '1vw', borderRadius: '0.5vw', backgroundColor: 'rgb(50, 128, 128, 0.8)' }}>
                    <img style={{ width: '2.5vw' }} src={SpeciaLogo} />
                  </div>
                </div>
                <div style={{ alignSelf: 'center', marginLeft: '0.5vw' }}>
                  <div style={{ flex: 1, textAlign: 'left', fontWeight: '400', fontSize: '1.2vw', marginBottom: '0.6vw', color: 'rgb(0, 15, 30, 0.8)' }}>{defaultPaymentMethod?.brand?.toUpperCase()}</div>
                  <div style={{ textAlign: 'right' }}>
                    ****
                    {defaultPaymentMethod?.last4}
                  </div>
                </div>
                {/* <div style={{flex: 1, textAlign: 'right', alignSelf: 'center'}}>
                                <ArrowForwardIosIcon style={{fontSize: '1vw'}}/>
                            </div> */}
                <div style={{ flex: 1, textAlign: 'right', marginTop: '1vw' }}>
                  Valid until
                  {defaultPaymentMethod?.exp_month}
                  /
                  {defaultPaymentMethod?.exp_year}
                </div>

              </div>
              <ButtonBase onClick={() => { setPaymentSetupShow(true); }} style={{ width: '100%', display: 'flex', flexDirection: 'row', padding: '1vw 1.5vw' }}>
                <div style={{ flex: 1, fontWeight: '600', textAlign: 'left' }}>
                  <p style={{ margin: 0 }}>Change Payment Method</p>
                </div>
                <div style={{ flex: 1, textAlign: 'right' }}>
                  <ArrowForwardIosIcon style={{ fontSize: '1vw' }} />
                </div>
              </ButtonBase>
              <ButtonBase
                onClick={() => {
                  setSnackBarMessage('Please contact us to remove your card from the system');
                  setSnackBarShow(true);
                }}
                style={{ width: '100%', display: 'flex', flexDirection: 'row', padding: '1vw 1.5vw', borderTop: '1px solid rgb(0, 15, 30, 0.05)' }}
              >
                <div style={{ flex: 1, fontWeight: '600', textAlign: 'left' }}>
                  <p style={{ margin: 0 }}>Delete Payment Method</p>
                </div>
                <div style={{ flex: 1, textAlign: 'right' }}>
                  <ArrowForwardIosIcon style={{ fontSize: '1vw' }} />
                </div>
              </ButtonBase>
            </>
          )}
          {!defaultPaymentMethod && (
            <ButtonBase onClick={() => { setPaymentSetupShow(true); }} style={{ width: '100%', display: 'flex', flexDirection: 'row', padding: '1vw 1.5vw' }}>
              <div style={{ flex: 1, fontWeight: '600', textAlign: 'left' }}>
                <p style={{ margin: 0 }}>Add Payment Method</p>
              </div>
              <div style={{ flex: 1, textAlign: 'right' }}>
                <ArrowForwardIosIcon style={{ fontSize: '1vw' }} />
              </div>
            </ButtonBase>
          )}
        </div>

      </div>

      {/* <div style={{display: 'flex', flexDirection: 'row', alignItems: 'flex-start'}}>

            <p style={{fontSize: '0.8vw', color: 'rgb(255, 255, 255, 0.6)', fontWeight:'300', flex: 1, margin: 0}}>Manage payment details</p>

            <Button style={{marginBottom: '1rem', padding: '1rem', borderRadius: '100rem', backgroundColor: 'rgb(255, 255, 255, 0.1)'}} onClick={() => {setPaymentSetupShow(true)}}>+</Button>

          </div> */}
      {/*
          <div style={{textAlign: 'right'}}>

            {paymentMethods.map(item =>
            <div style={{alignItems: 'center', display: 'flex', lineHeight: '1.2rem', flexDirection: 'row', backgroundColor: 'rgb(255, 255, 255, 0.05)', padding: '1.5rem 2rem', borderRadius: '0.8rem', marginBottom: '1rem'}}>

              <div style={{flex: 1, color: 'rgb(255, 255, 255, 0.8)', textAlign: 'left'}}>Visa **** {item.last4} { item.isDefault && <p>Default</p>}</div>
              <div style={{color: 'rgb(255, 255, 255, 0.7)', textAlign: 'right'}}> Expires {item.exp_month} {item.exp_year}</div>

            </div>)}

          </div> */}

      <Subscribe show={subscribeShow} reloadHandler={reload} closeHandler={subscribeCloseHandler} plans={plans} paygPlans={paygPlans} selectedFixedPlan={selectedFixedPlan} currentPaygRange={currentPaygRange} currentPlan={finalCurrentPlan} currentNoClients={currentNoClients} availablePlanTypes={availablePlans} />

      <SetupPayment show={paymentSetupShow} reloadHandler={fetchAvailablePaymentMethods} closeHandler={paymentSetupCloseHandler} />

      <CancelSubscription show={cancelSubscriptionShow} onHide={() => { setCancelSubscriptionShow(false); }} subId={finalCurrentPlan?.stripe_subscription_id} onReload={reload} />

    </div>
  );
}

export default Payment;
